import React, { useState } from "react";
import { developAxios } from "../axios.config";

const CheckCourses = () => {
	const [email, setEmail] = useState();
	const [course, setCourse] = useState([]);

	const handleClick = () => {
		developAxios(localStorage.getItem("token"))
			.post("/getCoursesByAccessList-by-email", { userEmail: email })
			.then(({ data }) => {
				console.log(data.courses);
				setCourse(data.courses);
			})
			.catch((e) => console.log(e));
	};

	return (
		<div>
			<div className="flex flex-row  justify-center  items-center">
				<div className="w-2/5	">
					<label className="block">
						<span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
							Email
						</span>
						<input
							type="email"
							name="email"
							className=" w-1/5	 mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
							placeholder="you@example.com"
							onChange={(e) => setEmail(e.target.value)}
						/>
					</label>
				</div>
				<div>
					<button
						onClick={handleClick}
						className=" m-8 rounded-none bg-teal-900 px-2 py-2 text-white	cursor-pointer "
					>
						Check Course
					</button>
				</div>
			</div>

			<div className="flex flex-row  justify-center  items-center">
				{course &&
					course.map((ele) => {
						return (
							<div
								key={ele._id}
								className=" m-8 max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700 "
							>
								<h5 className=" item-center mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white ">
									{ele.name}
								</h5>
							</div>
						);
					})}
			</div>
		</div>
	);
};

export default CheckCourses;
